import CareWork from "@/components/Shared/CareWork";
import CsrPageBanner from "@/components/CsrPage/CsrPageBanner";
import CsrPageGivingBack from "@/components/CsrPage/CsrPageGivingBack/component";
import CsrPageBlogFeed from "src/components/CsrPage/CsrPageBlogFeed";
import CsrPageHireCta from "src/components/CsrPage/CsrPageHireCta";
import SubmitForm from "@/components/Shared/SubmitForm";
import SEO from "@/components/SEO";
import localizePath from "@/functions/localizePath";

export default function CsrPage({ locale = "en" }) {
  return (
    <>
      <SEO
        path={localizePath("/csr", locale)}
        title="CSR | Lawrence Harvey"
        description="We are all responsible for a better tomorrow."
      />
      <main className="bg-white md:pt-[120px] sm:min-h-screen">
        <CsrPageBanner />
        <CsrPageGivingBack />
        <CareWork
          title="We care about the communities we work with?"
          dif="pink"
          path="service"
        />
        <div className="bg-purple">
          <CsrPageHireCta />
          <CsrPageBlogFeed />
          <SubmitForm />
        </div>
      </main>
    </>
  );
}
